import { Modal } from "@renderbus/ui";
import { ModalProps } from "antd";
import styled from "styled-components";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Button } from "@renderbus/ui";
import { useBindMini } from "./hooks/useBindMini";
import { LoadingOutlined } from "@ant-design/icons";

export function BindMiniProgramModal({
  modalProps,
}: {
  modalProps: ModalProps;
}) {
  const t = getTranslateNsT("center");
  const {
    isCurrentBindingWx,
    currentBindingWx,
    loadingQRCode,
    qrCodeUrl,
    handleBind,
  } = useBindMini(modalProps.open!);

  return (
    <Modal
      {...modalProps}
      width={"max-content"}
      children={
        <ContentWrapper>
          <QRCodeWrapper>
            {loadingQRCode && (
              <LoadingOutlined style={{ color: "black", fontSize: "60px" }} />
            )}
            {!loadingQRCode && !isCurrentBindingWx && (
              <img src={`data:image/png;base64,${qrCodeUrl}`} alt="qr-code" />
            )}
            {!loadingQRCode && isCurrentBindingWx && (
              <img src={currentBindingWx?.headimgurl} alt="avatar" />
            )}
          </QRCodeWrapper>
          <TextArea>
            {!isCurrentBindingWx && (
              <>
                <div>{t("header_notice_content_2")}</div>
                <div className="tip">{t("header_notice_content_1")}</div>
              </>
            )}
            {isCurrentBindingWx && (
              <div>
                {`
                ${t("user_bind_tip_pre")}${currentBindingWx?.nickname || ""}${t(
                  "user_bind_tip_sub"
                )}
                `}
              </div>
            )}
          </TextArea>
          <ConfirmButton
            disabled={!isCurrentBindingWx}
            type={isCurrentBindingWx ? "primary" : "default"}
            onClick={(e: any) => {
              handleBind(true);
              modalProps.onCancel!(e);
            }}
          >
            {t("user_binded_account_confirm")}
          </ConfirmButton>
        </ContentWrapper>
      }
      onCancel={(e) => {
        isCurrentBindingWx && handleBind(false);
        modalProps.onCancel!(e);
      }}
      footer={null}
    />
  );
}

const ConfirmButton = styled(Button)`
  position: absolute;
  width: 76px;
  height: 32px;
  background: #5c5d5f;
  border-radius: 4px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
`;

const TextArea = styled.div`
  max-width: 160px;
  margin-left: 28px;
  height: 148px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  line-height: 25px;
  color: #fafdfe;
  margin-right: 16px;
  .tip {
    font-size: 16px;
    line-height: 22px;
    color: #bfc2c3;
    margin-top: 4px;
  }
`;

const QRCodeWrapper = styled.div`
  width: 148px;
  height: 148px;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
`;

const ContentWrapper = styled.div`
  height: 216px;
  display: flex;
  position: relative;
`;
